import * as React from 'react';

const BrandArrow = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='12'
    viewBox='0 0 17 12'
    fill='none'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.3704 6.90307L1.07382 6.90307L1.07382 5.11481L16.3704 5.11481L16.3704 6.90307Z'
      fill='#200000'
    />

    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.888 6.12776L6.61769 10.7355L5.31974 12L0.590043 7.39225C-0.199201 6.62336 -0.192632 5.3811 0.585457 4.61224L0.590028 4.60773L5.31974 -1.02112e-06L6.61769 1.26449L1.8912 5.86911C1.81415 5.9467 1.82103 6.06253 1.888 6.12776Z'
      fill='#200000'
    />

    <path
      d='M15.1111 5.06961L15.1111 6.86961L16.3704 6.86961L17 5.06961L15.1111 5.06961Z'
      fill='#200000'
    />
  </svg>
);

export default BrandArrow;
